import { RESET_LEASE_STATUSES, SET_LEASE_STATUSES } from "./actionTypes";

const initialState = {
  leaseStatuses: {},
};

const leaseStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LEASE_STATUSES:
      return { ...state, leaseStatuses: { ...state.leaseStatuses, ...action.payload } };
    case RESET_LEASE_STATUSES:
      return initialState;
    default:
      return state;
  }
};

export default leaseStatusReducer;